import { render, staticRenderFns } from "./DocumentsEncode.vue?vue&type=template&id=0661288a"
import script from "./DocumentsEncode.vue?vue&type=script&lang=js"
export * from "./DocumentsEncode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports